import { checkDocument, Harpic } from '@buyhatke/custom-lib-js';

import {
	currenciesList,
	getCountryProperty,
	getCurrencyFromCode,
} from '@utils/params';

export const __selectCurrency = (_, selectedCurrency) => {
	const lowerSelectedCurrency = selectedCurrency.toLowerCase();

	if (checkDocument) {
		window.localStorage.setItem('selectedCurrency', lowerSelectedCurrency);
	}

	return {
		selectedCurrency: lowerSelectedCurrency,
	};
};

const __setInitialCurrency = ({ selectedCountry }) => {
	if (checkDocument) {
		const selectedCurrency = Harpic(
			window.localStorage.getItem('selectedCurrency')
		);

		if (selectedCurrency && currenciesList.indexOf(selectedCurrency) > -1) {
			return { selectedCurrency };
		}
	}

	//  if currency is not set already, then set based on user's Country
	return {
		selectedCurrency:
			getCurrencyFromCode(
				getCountryProperty(selectedCountry, 'currCode')
			) || 'inr',
	};
};

export const currencyActions = () => ({
	__selectCurrency,
	__setInitialCurrency,
});

export const initialCurrencyState = {
	selectedCurrency: 'inr',
};
